import styled from '@emotion/styled'
import React from 'react'

const Wrapper = styled.div`
`
type Props = {
    /** 色 */
    color?: string
}

/**
 * SVGアイコンコンポーネント
 * カルーセルバナー用矢印（左）
 */
const CarouselArrowLeftSvg = (props: Props): JSX.Element => (
  <Wrapper>
      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="20.25" viewBox="0 0 15 20.25">
          <path id="パス_5251" data-name="パス 5251" d="M15,0,7.021,10.123,15,20.25H7.976L0,10.123,7.976,0Z" fill={props.color}/>
      </svg>
  </Wrapper>
)
export default CarouselArrowLeftSvg
